import React from 'react';
import { ActionStatus, GamePlayerStatus } from '../../../../../Constants';
import AddGhost2d from './AddGhost';
import { RemoveGhosts2d } from './GhostingController';
import ReceiveSpecialGuest2d from './ReceiveSpecialGuest2d';
import RenovationController from './RenovationController';
import ScoreChoice from './ScoringController';
import { VanguardGivesLodging } from './VanguardGivesLodging';


// BoardActionRouter — the board-side slice of ActionRouter, for the
// Desktop preset. On mobile/Tablet/TV, GamePlayer2d mounts the full
// ActionRouter, which renders every action controller. On Desktop the
// action HUDs live in dedicated floating windows (ActionWindow /
// LodgingActionWindow / GhostActionWindow / ResearchActionWindow) and
// ActionRouter is never mounted. The controllers below are the
// exception: they render no HUD, they dispatch highlight-docks-event
// at HotelInterface so the player picks a dock on their own board.
// They have no dedicated-window home, so without this they go
// unmounted on Desktop and the docks never light (the regression).
//
// Mounted beside HotelInterface in the Desktop "Your Hotel" window —
// AFTER it, so HotelInterface's dock listener is registered before
// these dispatch on mount. Statuses owned by a dedicated window
// (LODGING, GHOSTING target/juice, RESEARCHING, TAKING_TURN,
// WAITING, DEFENDING) are deliberately absent: mounting
// them here would double the dedicated windows.
//
// AdvertisementPossibilities (the AC) is NO LONGER mounted here. It was
// converted to a singleton mounted once per seated Dashboard (see
// Dashboard.jsx) that gates its dispatches internally on
// ADVERTISING_ID + WAIT_ID. Mounting it here too would double the
// dispatcher and reintroduce the river mount-order race the singleton
// closes.
export default function BoardActionRouter(props) {
    const { gamePlayerData } = props;
    if (!gamePlayerData) return null;
    const status = gamePlayerData.status;
    const actionStatus = gamePlayerData.action_status;

    switch (status) {
    case GamePlayerStatus.ADVERTISING_ID:
        // Vanguard taken on: engine sets ADVERTISING_ID + ADD_ID and
        // waits for the player to pick a lodging permit. Mobile's
        // ActionRouter mounts VanguardGivesLodging here; Desktop's
        // dedicated windows don't cover this (status, action_status)
        // pair, so without this case the highlight-lodging-event
        // never fires on Desktop and the lodging selector never
        // lights up (the bug). The controller renders no HUD — it
        // just dispatches the highlight + click callback, matching
        // this file's "dispatcher-only" charter.
        if (actionStatus === ActionStatus.ADD_ID) {
            return <VanguardGivesLodging {...props}/>;
        }
        return null;
    case GamePlayerStatus.RENOVATING_ID:
        if (actionStatus === ActionStatus.WAIT_ID) {
            return <RenovationController {...props}/>;
        }
        return null;
    case GamePlayerStatus.SCORING_ID:
        return <ScoreChoice {...props}/>;
    case GamePlayerStatus.GHOSTING_ID:
        if (actionStatus === ActionStatus.REMOVE_ID) {
            return <RemoveGhosts2d {...props}/>;
        }
        return null;
    case GamePlayerStatus.GHOSTED_ID:
    case GamePlayerStatus.GHOST_STARTER_ID:
        return <AddGhost2d {...props}/>;
    case GamePlayerStatus.SPECIAL_ID:
        return <ReceiveSpecialGuest2d {...props}/>;
    default:
        return null;
    }
}
